import Icon from '../components/Icon.vue'

Icon.register({
  'dot-circle': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M256 8c137 0 248 111 248 248s-111 248-248 248-248-111-248-248 111-248 248-248zM336 256c0-44.1-35.9-80-80-80s-80 35.9-80 80 35.9 80 80 80 80-35.9 80-80z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/dot-circle.js
// module id = 1279
// module chunks = 0